import React from 'react';

import { Skeleton } from '@material-ui/lab';

import BaseSkeleton from '../BaseSkeleton';

import { DynamicFormSkeletonProps } from './DynamicFormSkeleton.types';

const DynamicFormSkeleton: React.FC<DynamicFormSkeletonProps> = ({
  className
}) => {
  return (
    <div className={`flex flex-column p2 ${className}`}>
      <BaseSkeleton width={200} height={40}  />
      <BaseSkeleton width={200} height={40} />
      <div className="flex flex-row mt4">
        <Skeleton variant="circle" width={30} height={30} className="mr4" />
        <Skeleton variant="circle" width={30} height={30} className="mr4" />
        <Skeleton variant="circle" width={30} height={30} className="mr4" />
        <Skeleton variant="circle" width={30} height={30} />
      </div>
      <div className="flex flex-row mt4">
        <Skeleton variant="rect" width={30} height={30} className="mr4" />
        <Skeleton variant="rect" width={30} height={30} className="mr4" />
        <Skeleton variant="rect" width={30} height={30} className="mr4" />
        <Skeleton variant="rect" width={30} height={30} />
      </div>
      <Skeleton variant="rect" height={30} className="width-100 mt4" />
    </div>
  );
};

export default DynamicFormSkeleton;
export { DynamicFormSkeletonProps };
